import { render, staticRenderFns } from "./CustomerReg.vue?vue&type=template&id=77d7dd72&"
import script from "./CustomerReg.vue?vue&type=script&scoped=true&lang=js&"
export * from "./CustomerReg.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./CustomerReg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports